document.addEventListener('DOMContentLoaded', async function () {
    const container = document.getElementById('okendo-reviews-wrapper');
    const apiUrl =
        'https://api.okendo.io/v1/stores/09f9e9e9-b49f-40fa-97fd-c71ee0c5e7c0/reviews?limit=10&orderBy=date%20desc';

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        // console.log('Okendo reviews data:', data);

        if (data.reviews && Array.isArray(data.reviews)) {
            const validReviews = data.reviews.filter((review) => {
                return review.productName && review.productImageUrl && review.status === 'approved';
                // return review.productName && review.productImageUrl && review.sentiment === 'positive';
            });

            container.innerHTML = validReviews
                .map((review) => {
                    const productName = review.productName;
                    const productImage = review.productImageUrl;
                    const productTitle = review.title;

                    return `
        <div class="swiper-slide">
          <div class="testimonial-card">
            <div class="testimonial-card__header">
              <img src="${productImage}" class="testimonial-card__image" alt="${productName}" width="63" height="63" loading="lazy" decoding="async">
              <div>
                <p class="testimonial-card__product">${productName}</p>
                <p class="testimonial-card__headline">${productTitle || 'Customer Review'}</p>
              </div>
            </div>
            <p class="testimonial-card__product__mobile">${productName}</p>
            <p class="testimonial-card__headline__mobile">${productTitle || 'Customer Review'}</p>
            <p class="testimonial-card__text">${review.body} - ${review.reviewer.displayName}</p>
          </div>
        </div>
      `;
                })
                .join('');
        }

        new Swiper('.testimonials__swiper', {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            navigation: {
                nextEl: '.ok-review-next',
                prevEl: '.ok-review-prev',
            },
            pagination: {
                el: '.swiper-pagination.testimonial-test',
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: true,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 32,
                },
            },
        });
    } catch (err) {
        console.error('Error loading reviews from Okendo:', err);
    }
});
